// This is just an example,
// so you can safely delete all default props below

export default {
  global: {
    CHOOSE_LANGUAGE: 'Choose Language',
    MISTAKE_SMS: 'Invalid OTP.',
    MISTAKE_PASSWORD: 'Incorrect password.',
    CLOSE: 'Close',
    UPDATE: 'Update',
    CANCEL: 'Cancel',
    OK: 'OK',
    gender: {
      MALE: 'Male',
      FEMALE: 'Female',
      OTHERS: 'others',
    },
    ALERT: 'Alert',
  },
  layouts: {
    MainLayout: {
      LOGIN_OR_SIGN_UP: 'Login / Sign up',
      MEMBER_AND_COUPON: 'Member & Coupon',
      MY_WALLET: 'My Wallet',
      EDIT_PROFILE: 'Edit Profile',
      TAG_DELIVERY: 'Tracking order',
      CHANGE_PASSWORD: 'Change Password',
      PRIVACY_POLICY: 'Privacy Policy',
      TERMS_OF_SERVICE: 'Terms of Service',
      SWITCH_LANGUAGE: 'Switch Language',
      SIGN_OUT: 'Sign out',
      VERSIONS: 'Version',
      DEVELOP: 'Developed by Privage',
    },
  },
  pages: {
    Consents: {
      HEADER: 'Terms and Consent',
      HINT: 'Please select your consent for the use of personal data for marketing activities.',
      ALLOWED: 'Agree',
      NOT_ALLOWED: 'Not agree',
      SAVE: 'Save',
      NEXT: 'Next'
    },
    CampaignDetail: {
      AVAILABLE_UNTIL: 'Available until',
      USE_BEFORE: 'Use before',
      CONDITION: 'Conditions',
      'POINT_{point}_PTS': 'Point {point} pts.',
      '{unit}_{point}_PTS': 'Require {unit} {point} {unit}.',
      AVAILABLE_QTY: 'Available Qty',
      MAX_USE: 'Max use',
      REQUIRED_CONDITION: 'Required Condition',
      GET_COUPON: 'Get Coupon',
      CONFIRM: 'Confirm',
      ARE_YOU_SURE_TO_GET_THIS_COUPON: 'Are you sure to get this coupon?',
      OK: 'OK',
    },
    ChangePassword: {
      CHANGE_PASSWORD: 'Change Password',
      CURRENT_PASSWORD: 'Current Password',
      NEW_PASSWORD: 'New Password',
      CONFIRM_NEW_PASSWORD: 'Confirm New Password',
      CHANGE_PASSWORD_SUCCESS: 'Change Password Success',
      CHANGE_PASSWORD_FAIL: 'Change Password Fail',
      CURRENT_PASSWORD_IS_REQUIRED: 'Current Password is required',
      NEW_PASSWORD_IS_REQUIRED: 'New Password is required',
      NOT_SAME_CURRENT_PASSWORD:
        'Cannot use the current password as a new password',
      PASSWORD_COMFIRMATION_NOT_MATCH:
        'The password confirmation does not match',
    },
    EditProfile: {
      MY_PROFILE: 'My Profile',
      FIRST_NAME: 'First name',
      LAST_NAME: 'Last name',
      GENDER: 'Gender',
      BIRTH_DATE: 'Date of birth',
      DAY: 'Day',
      MONTH: 'Month',
      YEAR: 'Year',
      EMAIL_ADDRESS: 'Email address',
      ADDRESS: 'Address',
      CITY: 'City/Province',
      ZIP: 'Zip',
      FIRST_NAME_IS_REQUIRED: 'First name is required',
      LAST_NAME_IS_REQUIRED: 'Last name is required',
      GENDER_IS_REQUIRED: 'Gender is required',
      EMAIL_IS_REQUIRED: 'Email is required',
      ADDRESS_IS_REQUIRED: 'Address is required',
      CITY_IS_REQUIRED: 'City/Province is required',
      ZIP_IS_REQUIRED: 'Zip is required',
      UPDATE_PROFILE_SUCCESS: 'Update profile success',
      Others: 'Others',
      KEY_YES: 'Yes',
      KEY_NO: 'No',
    },
    Error404: {
      OOPS_NOTHING_HERE: 'No Results',
      // OOPS_NOTHING_HERE: 'Oops. Nothing here...',
      GO_HOME: 'Go Home',
    },
    Member: {
      MEMBER: 'Member',
      POINT_HISTORY: 'Point History',
      AVAILABLE_CAMPAIGN: 'Campaigns',
      EARN_POINT: 'Earn points',
      USE_POINT: 'Redeem points',
      NO_CARD:
        'You dont have a membership card yet. Please contact to obtain a membership card from the administrator.',
    },
    Wallet: {
      MY_WALLET: 'My Wallet',
      AVAILABLE_COUPON: 'Available Coupon',
      EXPIRED_COUPON: 'Expired Coupon',
    },
    Pdpa: {
      SUBMIT: 'Submit my Request',
      REQUIRED: 'This field is required ',
      HEADING: 'Exercise your rights under PDPA',
      SUB_HEADING:
        'Send your PDPA request via the form below. Your request will be sent to the Data Protection Officer.',
      NAME: 'Name',
      LAST_NAME: 'Last Name',
      EMAIL: 'Email address',
      Claim: 'Claim',
      Claim_DETAIL: 'Claim Detail',
      UPLOAD: 'Upload proof of identity.',
      SUCCESS: 'Send Requests for personal information. success',
    },
  },
  components: {
    CampaignItem: {
      AVAILABLE_UNTIL: 'Available until',
      DELIVERY_FORM_DETAIL: 'Please fill out the information for delivery.',
      USE_BEFORE: 'Use before',
      CONDITIONS: 'Conditions',
      'POINT_{point}_PTS': 'Point {point} pts.',
      '{unit}_{point}_PTS': 'Require {unit} {point} {unit}',
      AVAILABLE_QTY: 'Available Qty',
      MAX_USE: 'Max use',
      REQUIRED_CONDITION: 'Required Condition',
      GET_COUPON: 'Get Coupon',
      UNUSABLE: 'Unusable',
      CONFIRM: 'Confirm',
      ARE_YOU_SURE_TO_USE_THIS_CAMPAIGN: 'Are you sure to use this campaign?',
    },
    CouponCountdown: {
      EXPIRED: 'Expired',
      COPY: 'Copy code',
      YOUR_TELEPHONE: 'Your phone number is',
    },
    CouponItem: {
      USE_BEFORE: 'Use before',
      ISSUED: 'Issued',
      ACTIVATE: 'Activate',
      CONFIRM: 'Confirm',
      COUPON_WILL_BE_EXPIRE_AFTER_ACTIVATE__ARE_YOU_CONFIRM_TO_ACTIVATE_THIS_COUPON:
        'Coupon will be expire after activate. Are you confirm to activate this coupon?',
      ERROR: 'Error',
      CANNOT_USE_THIS_COUPON__PLEASE_TRY_AGAIN:
        "Can't use this coupon. Please try again.",
    },
    LoginForm: {
      PHONE_NUMBER: 'Phone Number',
      PASSWORD: 'Password',
      PHONE_NUMBER_IS_REQUIRED: 'Phone number is required',
      PASSWORD_IS_REQUIRED: 'Password is required',
      REQUEST_OTP: 'Request OTP',
      OTP_IS_REQUIRED: 'OTP is required',
      PLEASE_ENTER_YOUR_OTP_RECEIVED_VIA_SMS_BELOW_OTP_IS_VALID_FOR_5_MINUTES:
        'Please enter your OTP received via SMS below. (OTP is valid for 5 minutes)',
      SHOW_PASSWORD: 'Show Password',
      OR: 'OR',
      TERMS_AND_CONDITIONS: 'Terms & Conditions',
      PRIVACY_POLICY: 'Privacy Policy',
      THIS_PHONE_NUMBER_IS_ALREADY_EXISTS_PLEASE_LINK_YOUR_PHONE_NUMBER:
        'This phone number is already exists. Please link your phone number.',
      PLEASE_ENTER_YOUR_MOBILE_NUMBER_TO_LOGIN:
        'Please enter your mobile number to login.',
      VERIFY_PHONE_NUMBER: 'Verify Phone Number',
      LOGIN: 'Login',
    },
    MemberCard: {
      YOUR_POINT: 'Your Point',
      'YOUR_{point}': 'Your {point}',
      POINT: 'point',
      VALUE: 'baht',
      UP: 'onwards',
      MAX_LEVEL: 'You have reached the maximum loyalty card level conditions.',
      CARD_PROMOTION: 'Card promotion',
      CARD_ADJUST: 'Next adjustment',
      CARD_ADJUST_PERIOD: 'Adjustment every',
      CARD_ADJUST_PERIOD_MONTH: 'Month',
      CARD_ADJUST_PERIOD_YEAR: 'Year',
      NEED_POINT_OR_VALUE: 'Require {unit}',
      EXPIRE_POINT: 'Point will expire',
      'EXPIRE_{point}': '{point} will expire',
      NOT_EXPIRE_POINT: 'Points have no expiration date.',
      MEMBER_NAME: 'Member',
      CARD_ID: 'Card No',
      CARD_TYPE: 'Type of Card',
      DOWNGRADE_TO: 'Downgrade to',
      CARD_INFO: 'Info',
      CARD_WILL_DOWNGRADE: 'Type of Card will downgrade to',
      WHEN: 'at',
      POINT_HISTORY: 'Point History',
      YEAR_SCORE: 'You have a current {unit} balance',
    },
    RegisterForm: {
      PHONE_NUMBER: 'Phone Number',
      FIRST_NAME: 'First name',
      LAST_NAME: 'Last name',
      NEW_PASSWORD: 'New password',
      DATE_OF_BIRTH: 'Date of birth',
      EMAIL_ADDRESS: 'Email address',
      FIRST_NAME_IS_REQUIRED: 'First name is required',
      LAST_NAME_IS_REQUIRED: 'Last name is required',
      PASSWORD_IS_REQUIRED: 'Password is required',
      GENDER_IS_REQUIRED: 'Gender is required',
      EMAIL_IS_REQUIRED: 'Email is required',
      ADDRESS_IS_REQUIRED: 'Address is required',
      CITY_IS_REQUIRED: 'City/Province is required',
      ZIP_IS_REQUIRED: 'Zip is required',
      I_HAVE_READ_AND_ACCEPT_THE_TERMS: 'I have read and accept the',
      TERMS_AND_CONDITIONS: 'Terms & Conditions {business}',
      I_HAVE_READ_AND_ACCEPT_THE_PRIVACY: 'I have read and accept the',
      PRIVACY_POLICY: 'Privacy Policy {business}',
      YOU_MUST_READ_AND_ACCEPT:
        'You must read and accept the Term of Service and Privacy Policy',
      BY_CLICKING_SIGN_UP_YOU_AGREE_TO_OUR:
        'By clicking Sign Up, you agree to our',
      AND: 'and',
      VERIFY_ACCOUNT: 'Verify Account',
      SIGN_UP: 'Sign Up',
      CONFIRM: 'Confirm',
      BRANCH: 'Branch',
      SOMETHING_WENT_WRONG:
        'Something went wrong. Please contact administrator',
    },
    Delivery: {
      pending: 'In Progress',
      done: 'Done',
      SUBMIT_DATA_COMPLETE: 'Submit delivery data complete',
    },
    PointHistoryItem: {
      EARN: 'Earn {unit_point}',
      USE: 'Burn {unit_point}',
      VOID: 'Voided {unit_point}',
      FORCE_VOID: 'Voided {unit_point}',
      VOID_USE: 'Voided {unit_point}',
      BALANCE: 'Balance {unit_point}',
      EXPIRED: 'Expired {unit_point}',
      VOID_EXPIRED: 'Voided {unit_point}',
    },
  },
  ONLY_LOGIN: 'Only login user',
  USE_EXPIRE: 'Campaign use expired',
  NOT_START: 'Campaign not start',
  NOT_AVAILABLE: 'Campaign not available',
  ONLY_STAFF: 'Must use by staff',
  NOT_ACTIVE: 'Campaign not active',
  NOT_ENOUGH_POINT: 'Not enough {unit}',
  MEMBER_CARD_EXPIRED: 'Member Card Expired',
  LIMIT_REACH: 'Limit reach',
  LIMIT_PER_DAY: 'Reach limit per day',
  LIMIT_PER_MONTH: 'Reach limit per month',
  LIMIT_PER_YEAR: 'Reach limit per year',
  LIMIT_PER_CAMPAIGN: 'Reach limit per campaign',
  COUPON_NOT_AVAILABLE: 'Coupon not available',
  CARD_TYPE_NOT_MATCH: 'Card type not match',
  ALREADY_USE: 'Already use',
  NO_BIRTHDAY_SET: 'User not set birthday',
  NOT_BIRTH_MONTH: 'Not in birth month',
  INVALID_CONFIG: 'Invalid config',
  CONSENT: {
    ACCEPTED: 'Last Accepted',
    BUTTON: {
      REFRESH: 'Go Back',
      ACCEPT: 'Accept',
      DENY: 'Deny',
      READ_MORE: 'Read more',
    },
    WARN:
      'You are unable to use the system because you have not accepted the latest Terms and Conditions or Privacy Policy',
  },
}
